import { simpleObject, hashCode } from '../lib/utils';

class MessageSender {
  constructor() {
    this.target = window.parent;
    this.twoWayMessageCallbacks = {}; // { id: callback }
    this.messageQueue = [];
    this.remoteReady = false;
    this.targetOrigin = '*';
    this.validMessageOrigins = '*';
  }

  start() {
    window.addEventListener('message', this.receiveMessage, false);
  }

  stop() {
    window.removeEventListener('message', this.receiveMessage);
  }

  send(data, callback) {
    if (typeof this.target === 'undefined') {
      return false;
    }
    data.id = data.id + hashCode(JSON.stringify(data));
    if (callback) {
      this.twoWayMessageCallbacks[data.id] = callback;
    }
    const message = simpleObject(data);
    if (this.remoteReady) {
      this.target.postMessage(message, this.targetOrigin);
    } else {
      this.messageQueue.push(message);
    }
  }

  receiveMessage = event => {
    const { data, source, origin } = event;
    const isOrginAllowed = this.checkOriginPermission(origin);
    if (isOrginAllowed === false) {
      console.error(
        `[receiveMessage] message received from unpermitted origin` +
          ` ${origin}. Abort.`
      );
      return;
    }
    const { id, action, detail, success } = data;
    if (action) {
      // handle action
      data.source = source;
      const event = new CustomEvent('message:action', {
        detail: data
      });
      window.dispatchEvent(event);
    } else {
      // response
      if (this.twoWayMessageCallbacks[id]) {
        this.twoWayMessageCallbacks[id](success, detail);
        delete this.twoWayMessageCallbacks[id];
      }
    }
  };

  postFullQueue() {
    while (this.messageQueue.length > 0) {
      this.postNext();
    }
  }

  postNext() {
    const message = this.messageQueue.shift();
    if (message) {
      this.target.postMessage(message, this.targetOrigin);
      return true;
    } else {
      return false;
    }
  }

  checkOriginPermission(origin) {
    const validOrigins = this.validMessageOrigins;

    if (validOrigins === '*') {
      return true;
    } else if (Array.isArray(validOrigins) && validOrigins.includes(origin)) {
      return true;
    } else if (typeof validOrigins === 'string' && validOrigins === origin) {
      return true;
    } else {
      return false;
    }
  }
}

export default MessageSender = new MessageSender();



/** WEBPACK FOOTER **
 ** ./~/web-message-helper/src/sender.js
 **/